import { Sync } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';
import { useState } from 'react';
import { Button, Identifier, useDataProvider, useNotify, useRefresh } from 'react-admin';
import type { GPDataProvider } from '../../DataProvider';
import { getJsonApiErrorDetail } from '../../utils';

interface SyncWithNetSuiteButtonProps {
  merchantId?: Identifier;
}

export default function SyncWithNetSuiteButton({ merchantId }: SyncWithNetSuiteButtonProps) {
  const dataProvider = useDataProvider<GPDataProvider>();
  const notify = useNotify();
  const refresh = useRefresh();
  const [isPending, setIsPending] = useState(false);

  const handleClick = async () => {
    if (merchantId == null) {
      notify('Save this merchant before syncing with NetSuite.', { type: 'warning' });
      return;
    }

    try {
      setIsPending(true);
      const result = await dataProvider.merchantSyncWithNetSuite(merchantId);
      notify(result?.meta.message ?? 'NetSuite is already in sync for this merchant.', {
        type: 'success',
      });
      refresh();
    } catch (error) {
      notify(getJsonApiErrorDetail(error, 'NetSuite sync failed'), { type: 'error' });
    } finally {
      setIsPending(false);
    }
  };

  return (
    <Button
      label="Sync with NetSuite"
      variant="contained"
      color="primary"
      disabled={isPending}
      startIcon={isPending ? <CircularProgress size={16} /> : <Sync fontSize="small" />}
      onClick={handleClick}
    />
  );
}
